import React, { Fragment, useEffect, useState } from "react";
import {
  CollapseDownIcon,
  CollapseUpIcon,
} from "../../../../assets/icons/index";
import { getLiftOffGalaxyStandard } from "../../../../api/liftOffGalaxyStandard.service";
import { ILiftOffGalaxyTopic } from "../../../../model/interface/liftOffGalaxyStandard";
import { connect } from "react-redux";
import Loader from "../../../shared/loader/loader";
import { DownArrowIcon, UpArrowIcon } from "../../../../assets/icons/index";
import { Disclosure, DisclosureButton } from "@headlessui/react";
import {
  IStandardGroupStandardDTO,
  IStandardGroupStandardSearchRequest,
} from "../../../../model/interface/standardGroup";
import { getStandardGroupStandards } from "../../../../api/standardGroup.service";
import Item from "antd/lib/list/Item";
import { IStandardExistsRequest } from "../../../../model/interface/liftOffDiagnosticTest";
import { checkStandardExists } from "../../../../api/liftOffDiagnosticTestQuestion.service";
import { toast } from "react-toastify";

interface GalaxyCardProps {
  liftOffHeaderId: number;
  liftOffGalaxyId: number;
  liftOffGalaxyName: string;
  isLastGalaxyCard: boolean;
  isGalaxyCardSelected: boolean;
  setDisableAddGalaxy: (disable: boolean) => void;
  onClicked: (lfGalaxyId) => void;
  profile: any;
  setSelectedStandards: (
    selectedStandardIds: Array<ILiftOffGalaxyTopic>
  ) => void;
  selectedStandards: Array<ILiftOffGalaxyTopic>;
  testId: number;
  subjectId: number;
}

const GalaxyCardInPopup = (props: GalaxyCardProps) => {
  const defaultPageNumber = 1;
  const defaultPageSize = 9999;
  const [loading, setLoading] = useState(false);
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [toggle, setToggle] = useState<number>();
  const [galaxyTopics, setGalaxyTopics] = useState<Array<ILiftOffGalaxyTopic>>(
    []
  );
  const [groupedStandards, setGroupedStandards] = useState<
    Array<IStandardGroupStandardDTO>
  >([]);
  const [selectedStandardIds, setSelectedStandardIds] = useState<Array<number>>(
    []
  );
  const [toggleCard, setToggleCard] = useState<boolean>(true);
  useEffect(() => {
    getData();
  }, [props.liftOffHeaderId, toggleCard, pageNumber, props.liftOffGalaxyId]);

  const getData = () => {
    if (toggleCard) {
      getLiftOffGalaxyStandard(
        props.liftOffHeaderId,
        props.liftOffGalaxyId,
        true,
        pageNumber,
        pageSize
      ).then((r) => {
        setGalaxyTopics(r.data.data);
      });
    }
  };

  const handleShowGroupedStandards = async (standardGroupId, index?, type?) => {
    setLoading(true);
    if (type === "show") {
      const groupStandardSearchReq: IStandardGroupStandardSearchRequest = {
        standardGroupId: standardGroupId,
        standardId: 0,
        isActive: true,
      };
      const response = getStandardGroupStandards(
        groupStandardSearchReq,
        1,
        99999
      );
      const data = (await response).data;
      setGroupedStandards(data.data);
      setToggle(index);
    } else {
      setToggle(undefined);
    }
    setLoading(false);
  };

  const onStandardSelection = async (e, standardId) => {
    const isValid = await validateStandard(standardId);
    if (isValid == false) {
      const elem: any = document.getElementById(`${standardId}`);
      if (elem) elem.checked = false;
    } else {
      let ds = props.selectedStandards.map((item) => item.standardId);
      if (e.target.checked) {
        if (selectedStandardIds.length) {
          if (!selectedStandardIds.includes(standardId)) {
            ds.push(standardId);
            setSelectedStandardIds(ds);
          } else {
            setSelectedStandardIds(ds);
          }
        } else if (e.target.checked) {
          ds.push(standardId);
          setSelectedStandardIds([standardId]);
        }

        for (let i = 0; i < selectedStandardIds.length; i++) {
          const elem: any = document.getElementById(`${standardId}`);
          if (elem) elem.checked = true;
        }
      }

      if (e.target.checked === false) {
        let removedUnchecked: any = [];
        removedUnchecked = selectedStandardIds.filter((d) => d !== standardId);
        ds = removedUnchecked;
        setSelectedStandardIds(removedUnchecked);
        const elem: any = document.getElementById(`${standardId}`);
        if (elem) elem.checked = false;
      }
      let standards = galaxyTopics.filter(
        (item) =>
          ds.indexOf(item.standardId) !== -1 &&
          props.selectedStandards
            .map((s) => s.standardId)
            .indexOf(item.standardId) === -1
      );

      standards = props.selectedStandards
        .filter(
          (s) =>
            standards.map((item) => item.standardId).indexOf(s.standardId) ===
            -1
        )
        .concat(standards);

      //const uniqueStandards = [...new Set(standards.map((item) => item))];
      props.setSelectedStandards(standards);
    }
  };

  const validateStandard = async (standardId: number) => {
    let isValid = true;
    const request: IStandardExistsRequest = {
      liftOffDiagnosticTestId: props.testId,
      standardReferenceId: standardId,
      subjectId: props.subjectId,
    };
    const response = checkStandardExists(request);
    const data = (await response).data;
    if (data.standardPresentInTest) {
      toast.error("Standard/Standard Group already added to other heirarchy");
      isValid = false;
      return isValid;
    }
    return isValid;
  };

  return (
    <Fragment>
      <div
        className="mt-6 cursor-pointer bg-gray-50 sm:pr-6 lg:pr-8 lg:flex-shrink-0 lg:border-l lg:border-gray-200 xl:pr-0 shadow overflow-hidden border border-gray-200 sm:rounded-lg m-auto"
        onClick={() => {
          props.onClicked(props.liftOffGalaxyId);
        }}
      >
        {loading && <Loader></Loader>}
        <div className="p-4">
          <div className="mb-2 grid grid-cols-2">
            <div className="flex justify-start items-center">
              {!toggleCard && (
                <DownArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              {toggleCard && (
                <UpArrowIcon
                  className="h-5 w-5 ml-1 text-gray-500"
                  onClick={() => {
                    setToggleCard(!toggleCard);
                  }}
                />
              )}
              <h3 className="ml-2">{props.liftOffGalaxyName}</h3>
            </div>

            <div className="flex justify-end">
              {!toggleCard && (
                <span> Standards {galaxyTopics ? galaxyTopics.length : 0}</span>
              )}
            </div>
          </div>
          {toggleCard && (
            <Fragment>
              <div className="flex-grow overflow-hidden rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-primary-color">
                    <tr>
                      <th></th>
                      <th
                        scope="col"
                        className="font-light text-sm text-left text-white tracking-wider"
                      >
                        <span className="flex"></span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 whitespace-nowrap font-light text-sm text-left text-white tracking-wider"
                      >
                        <span className="flex">Order</span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                      >
                        <span className="flex">Code</span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                      >
                        <span className="flex">Standard / Group</span>
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-2 whitespace-nowrap font-light text-sm text-center text-white tracking-wider"
                      >
                        <span className="flex">Is Grouped</span>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {galaxyTopics &&
                      galaxyTopics.map((topic, index) => {
                        const standardId: any = topic.standardId;
                        return (
                          <Disclosure key={index}>
                            <>
                              <tr
                                key={index}
                                className={
                                  index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                }
                              >
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  {" "}
                                  <label className="flex items-center mr-2">
                                    <input
                                      id={standardId}
                                      name="isActive"
                                      type="checkbox"
                                      onChange={(e) =>
                                        onStandardSelection(e, standardId)
                                      }
                                      className="focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded cursor-pointer"
                                    />
                                  </label>
                                </td>
                                <td>
                                  {topic.isStandardGrouped && (
                                    <div>
                                      <DisclosureButton>
                                        {index !== toggle && (
                                          <CollapseDownIcon
                                            key={index}
                                            className={`w-5 h-5 text-gray-500`}
                                            onClick={(e) => {
                                              handleShowGroupedStandards(
                                                topic?.standardId,
                                                index,
                                                "show"
                                              );
                                            }}
                                          />
                                        )}

                                        {index === toggle && (
                                          <CollapseUpIcon
                                            key={index}
                                            className={`w-5 h-5 text-gray-500`}
                                            onClick={(e) => {
                                              handleShowGroupedStandards(
                                                topic?.standardId,
                                                index,
                                                "hide"
                                              );
                                            }}
                                          />
                                        )}
                                      </DisclosureButton>
                                    </div>
                                  )}
                                </td>
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  {topic.orderNumber}
                                </td>
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  {topic.code ? topic.code : "-"}
                                </td>
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  {topic.standardName}
                                </td>
                                <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                  {topic.isStandardGrouped ? "yes" : "No"}
                                </td>
                              </tr>
                              <tr>
                                <td colSpan={8}>
                                  <div
                                    className={`${
                                      index !== toggle ? "hidden" : ""
                                    }  px-4 pt-4 pb-2 text-sm text-gray-500`}
                                  >
                                    <div className="shadow border rounded-lg px-3 py-3">
                                      <table className="min-w-full">
                                        <thead>
                                          <tr className="bg-gray-100">
                                            <th
                                              scope="col"
                                              className="inline-flex items-center gap-2 px-3 py-2 pl-6 font-normal text-gray-500 text-xs uppercase text-left tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Standard Id
                                              </span>
                                            </th>
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 font-normal text-xs uppercase text-left text-gray-500 tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Code
                                              </span>
                                            </th>
                                            <th
                                              scope="col"
                                              className="px-3 py-2 pl-6 font-normal text-xs uppercase text-left text-gray-500 tracking-wider"
                                            >
                                              <span className="flex gap-2">
                                                Name
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody className="divide-y divide-gray-50">
                                          {groupedStandards.map(
                                            (standard, index) => (
                                              <tr key={index}>
                                                <td className="font-medium pl-6">
                                                  {standard.standardId}
                                                </td>
                                                <td className="px-3 py-2  pl-6 whitespace-nowrap text-sm text-left font-normal text-gray-500">
                                                  {standard.standardCode}
                                                </td>
                                                <td className="px-3 py-2  text-sm text-left font-normal text-gray-500">
                                                  {standard.standardName}
                                                </td>
                                              </tr>
                                            )
                                          )}
                                        </tbody>
                                      </table>
                                    </div>{" "}
                                  </div>
                                </td>
                              </tr>
                            </>
                          </Disclosure>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(GalaxyCardInPopup);
